import {
  InternalServerError,
  NotAuthenticated,
  NotAuthorized,
  NotFoundError,
  ValidationError,
} from '@module/mdrt-org/shared/utils/http-services/error-definitions';
import { GENERIC_ERROR_TRANSLATION_KEY } from '@shared/utils/constants/errors';

export const throwResponseErrors = async (response: Response) => {
  const result = await response.json().catch(() => undefined);

  switch (response.status) {
    case 400:
      if (result) {
        throw new ValidationError({
          message: result.message,
          messageTranslationKey: result.messageTranslationKey ?? GENERIC_ERROR_TRANSLATION_KEY,
        });
      } else {
        throw new ValidationError({
          message: 'Invalid request.',
          messageTranslationKey: GENERIC_ERROR_TRANSLATION_KEY,
        });
      }

    case 401:
      throw new NotAuthenticated();
    case 403:
      throw new NotAuthorized();
    case 404:
      throw new NotFoundError();
    default:
      throw new InternalServerError();
  }
};
